import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import { NavLink } from "react-router-dom";
import { Icon } from '@iconify/react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg sticky-top pt-3 pb-5 px-0 px-sm-2 px-md-5">
        <div className="container-fluid">
          <button
            className="navbar-toggler p-0 border border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleToggleMenu}
          >
            {isMenuOpen ? (
              <Icon className="close_icon" fontSize="40px" color="white" icon="material-symbols:close" />
            ) : (
              <Icon className="menu_icon" fontSize="40px" color="white" icon="material-symbols:menu" />
            )}
          </button>

          <NavLink to="/" style={{ textDecoration: "none" }} className="text-white p-0" onClick={()=>setIsMenuOpen(false)}>
            <img className="navbar_logo" width="110px" src={logo} alt="" />
          </NavLink>

          <div className={`collapse navbar_menu navbar-collapse h-100 py-5 w-60 ${isMenuOpen ? "show" : ""}`} id="navbarSupportedContent">
            <ul className="navbar-nav gap-4">
              <li className="nav-item" onClick={()=>setIsMenuOpen(false)}>
                <a className="nav-link  text-white" href="#aboutus" >
                  ABOUT US
                </a>
              </li>
              <li className="nav-item dropdown" onClick={()=>setIsMenuOpen(false)} >
                <a
                  className="nav-link  active text-white dropbtn"
                  aria-current="page"
                  href="#"
                >
                  OVERVIEW
                </a>
                {/* <div className="dropdown-content">
                  <a className=" text-white dropbtn" href="#aboutcryowar">ABOUT SIEGE
            </a>

                  <a className=" text-white dropbtn" href="#solanaplateform">BLOCKCHAIN INTEGRATION</a>
                  <a className=" text-white dropbtn" href="#gamemodes">GAMEPLAY</a>
                  <a className=" text-white dropbtn" href="#heroes">MEET THE HEROES</a>

                </div> */}
              </li>
              <li className="nav-item" onClick={()=>setIsMenuOpen(false)}>
                <a className="nav-link  text-white" href="#ourstory">
                  OUR STORY
                </a>
              </li>
              <li className="nav-item" onClick={()=>setIsMenuOpen(false)}>
                <a className="nav-link  text-white" href="#gameplay">
                  GAME PLAY
                </a>
              </li>
              <li className="nav-item" onClick={()=>setIsMenuOpen(false)}>
                <a className="nav-link  text-white" target="_blank" href="/whitepaper.pdf">
                  WHITE PAPER
                </a>
              </li>
              <li className="nav-item"onClick={()=>setIsMenuOpen(false)}>
                <a className="nav-link  text-white" href="#ourteam">
                  TEAM
                </a>
              </li>
              <li className="nav-item" onClick={()=>setIsMenuOpen(false)}>
                <a className="nav-link  text-white" href="#partner">
                  PARTNER
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
